module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-03-aa281674142d5ed7deb33bb2db072a66.webp";